import { TaskType } from "../actions/task";

export const taskState = {
  myAssignedTasks: [],
  taskLoading: false,
};

export const taskReducer = (state = taskState, action) => {
  switch (action.type) {
    case TaskType.GET_MY_ASSIGNED_TASKS:
      return { ...state, taskLoading: true };
      
    case TaskType.SET_MY_ASSIGNED_TASKS:
      return { ...state, myAssignedTasks: action.payload, taskLoading: false };
      
    case TaskType.SET_TASK_LOADING:
      return { ...state, taskLoading: action.payload };
      
    default:
      return state;
  }
};
